import { Component, inject, OnInit } from '@angular/core';
import { BreadcrumbsComponent } from '../../shared/widgets/breadcrumbs/breadcrumbs.component';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { PageTitleService } from '../../shared/services/page-title.service';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderWidgetComponent } from '../../shared/widgets/loader-widget/loader-widget.component';
import { SignalStore } from '../../../store/app.store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ProfileSettingsModalComponent } from '../../components/modals/profile-settings-modal/profile-settings-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AccountMenuComponent } from '../../components/account-menu/account-menu.component';
import {IconAccountComponent} from "../../components/icons/icon-account/icon-account.component";
import {IconAnswerComponent} from "../../components/icons/icon-answer/icon-answer.component";
import {IconFavoriteComponent} from "../../components/icons/icon-favorite/icon-favorite.component";
import {IconDraftComponent} from "../../components/icons/icon-draft/icon-draft.component";
import {IconLogoutComponent} from "../../components/icons/icon-logout/icon-logout.component";

@Component({
  selector: '#home-layout',
  imports: [
    BreadcrumbsComponent,
    RouterOutlet,
    TranslateModule,
    LoaderWidgetComponent,
    TranslateModule,
    AccountMenuComponent,
    IconAccountComponent,
    IconAnswerComponent,
    IconFavoriteComponent,
    IconDraftComponent,
    IconLogoutComponent,
  ],
  templateUrl: './home-layout.component.html',
  styleUrl: './home-layout.component.scss',
  standalone: true,
})
export class HomeLayoutComponent implements OnInit {
  showRoute = false;
  readonly store = inject(SignalStore);
  user = this.store.getUser();

  constructor(
    private $auth: AuthService,
    private $router: Router,
    private $ts: TranslateService,
    public $title: PageTitleService,
    private $modal: MatDialog,
    private route: ActivatedRoute,
    private $location: Location,
    private $toast: MatSnackBar,
  ) {}

  ngOnInit() {
    if (this.route.snapshot.queryParamMap.has('error')) {
      try {
        const error = JSON.parse(
          this.route.snapshot.queryParamMap.get('error')!,
        );
        if (error.code === 'SOCIAL_ACCOUNT_ALREADY_EXISTS') {
          error.message = this.$ts.instant(
            'error.SOCIAL_ACCOUNT_ALREADY_EXISTS',
          );
        }
        this.$toast.open(error.message, undefined, {
          duration: 3000,
          panelClass: 'error',
        });
      } catch (e) {
        //
      } finally {
        this.$router.navigate([location.pathname]).then();
      }
    }
    if (this.route.snapshot.queryParamMap.has('social_binding')) {
      if (this.route.snapshot.queryParamMap.get('social_binding') === 'OK')
        this.$toast.open(this.$ts.instant('global.updated'), undefined, {
          duration: 3000,
          panelClass: 'success',
        });
      this.$router.navigate([location.pathname]).then();
    }
    if (window.location.hash === '#profile') {
      this.$modal
        .open(ProfileSettingsModalComponent, {
          width: '400px',
          panelClass: ['outer-close', 'white', 'btn-back'],
          autoFocus: false,
          disableClose: window.innerWidth >= 768,
        })
        .afterOpened()
        .subscribe(() => {
          this.showRoute = false;
          const pathWithHash = this.$location.path() + '#profile';
          this.$location.replaceState(pathWithHash);
        });
    }
  }

  navigateTo(url: string) {
    if (url === 'logout') {
      this.$auth.logOut();
      return;
    }
    if (url === 'profile') {
      this.$modal
        .open(ProfileSettingsModalComponent, {
          width: '400px',
          panelClass: ['outer-close', 'white', 'btn-back'],
          autoFocus: false,
          disableClose: window.innerWidth >= 768,
        })
        .afterOpened()
        .subscribe(() => {
          const pathWithHash = this.$location.path() + '#profile';
          this.$location.replaceState(pathWithHash);
        });
      return;
    }
    this.$router.navigate(['/' + url]).then();
  }

  protected readonly window = window;
}
